<template>
  <div
    class="mx-auto mt-3 d-flex flex-column align-items-center"
    style="border-radius: 20px; height: 80vh; position: relative"
  >
              <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'کارت ویزیت'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

    <v-img :src="value.photo.profile" class="image_style"></v-img>
    <v-card
      elevation="2"
      :color="value.pallete.headColor"
      rounded="xl"
      class="position-relative d-flex flex-column align-items-center justify-content-center"
      :style="{
        width: '80%',
        height: '20vh',
        background: !!value.photo.headBackground
          ? 'transparent'
          : value.pallete.headColor,
      }"
    >
      <div
        v-if="!!value.photo.headBackground"
        :style="{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${value.photo.headBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0,
          opacity: value?.photo?.headTransparent ?? 0.1
        }"
      ></div>
      <v-card-title
        elevation="2"
        class="d-flex justify-content-center marquee-container mr-6 w-100"
        style="max-width: 100%; overflow: hidden;"
        ref="containerRef"
      >
        <span
          ref="textRef"
          :class="{ 'marquee-text': isOverFlowLabel }"
          :style="{
            color: value.pallete.textColor,
            fontSize: '30px',
            fontWeight: '800',
            zIndex: 1,
          }"
          >{{ value.gold.goldName }}</span
        >
      </v-card-title>
      <v-card-title
        class="d-flex justify-content-center marquee-container ml-4 w-100"
        style="max-width: 100%; overflow: hidden;"
        ref="containerLabelRef"
      >
        <span
          ref="textName"
          :class="{ 'marquee-text-slow': isOverFlowLabelName }"
          :style="{
            color: value.pallete.textColor,
            fontSize: '20px',
            fontWeight: '400',
            zIndex: 1,
          }"
          >{{ value.gold.name }}</span
        >
      </v-card-title>
    </v-card>

    <!-- <v-card
      elevation="1"
      :style="{
        background: value?.pallete?.headColor,
        width: '4rem',
        maxHeight: '430px',
        zIndex: '99',
        padding: '5px 0',
        bottom:
          socialMediaSlice.length > 3
            ? socialMediaSlice.length < 8
              ? `${50 - socialMediaSlice.length * 5}%`
              : `0`
            : null,
      }"
      v-if="socialMediaSlice.length > 0"
      rounded="xxl"
      class="menu d-flex flex-column align-items-center"
    >
      <div class="d-flex flex-column align-items-center">
        <v-tooltip
          v-if="
            socialMediaSlice?.length === socialMedia?.length &&
            socialMediaSlice?.length > 3
          "
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="white"
              height="50"
              class="social mt-1"
              style="cursor: pointer"
              @click="deletSocialMedia"
            >
              mdi-dots-horizontal
            </v-icon>
          </template>
          <span>کمتر</span>
        </v-tooltip>

        <v-tooltip
          v-if="
            socialMediaSlice?.length < socialMedia?.length &&
            socialMedia.length > 2
          "
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="white"
              height="40"
              class="social my-1"
              style="cursor: pointer"
              @click="addSocialMedia"
            >
              mdi-dots-horizontal
            </v-icon>
          </template>
          <span>بیشتر</span>
        </v-tooltip>
      </div>

      <div
        class="w-100 scrollable-icons"
        style="overflow-y: auto; max-height: 400px"
      >
        <div class="d-flex flex-column align-items-center">
          <v-tooltip v-for="(social, i) in socialMediaSlice" :key="i" right>
            <template v-slot:activator="{ on, attrs }">
              <a
                v-bind="attrs"
                v-on="on"
                @click="goToUrl(social.url, social.pattern)"
                target="_blank"
                class="social mt-1 animated-social"
                style="
                  width: 40px;
                  height: 50px;
                  border-radius: 50%;
                  overflow: hidden;
                  cursor: pointer;
                "
              >
                <v-img
                  :src="social.img"
                  contain
                  style="width: 100%; height: 100%"
                />
              </a>
            </template>
            <span>{{ social.label }}</span>
          </v-tooltip>
        </div>
      </div>
    </v-card> -->

    <floating-btn-gold
      v-if="value.socialMedia && Object.keys(value.socialMedia).length > 0"
      v-model="value.socialMedia"
      :background="value.pallete.headColor"
      :color="value.pallete.textColor"
      class="position-absolute"
      style="bottom: 20px; left: 90px; z-index: 10 !important"
    />

    <v-card
      class="mt-5"
      :style="{
        position: 'relative',
        overflowY: 'auto',
        width: '80%',
        minHeight: '60vh',
        borderRadius: '15px',
        background: !!value.photo.background
          ? 'transparent'
          : value.pallete.bodyColor,
      }"
      ref="card_label"
    >
      <div
        v-if="!!value.photo.background"
        :style="{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: `${imageHeight}px`,
          backgroundImage: `url(${value.photo.background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0,
          opacity: value?.photo?.backgroundTransparent ?? 0.1
        }"
        ref="imageBackground"
      ></div>
      <div
        ref="menuBackground"
        class="mx-2 pa-2"
        :style="{
          width: '85%',
          zIndex: '2',
          position: 'relative',
          color: value.photo.textColor 
        }"
      >
        <drag-list v-model="gold">
          <template v-slot:default="{ item }">
            <template
              v-if="
                item === 'price' && value.gold.price.text?.toString().length > 0
              "
            >
              <div
                class="w-100 pt-1"
                :class="value.gold.price.line ? 'line pa-3' : null"
              >
                <v-btn
                  elevation="0"
                  :style="{
                    background: value.pallete.headColor,
                    color: value.pallete.textColor,
                  }"
                  class="px-1 py-0.5"
                  :loading="dbLoading"
                >
                  <span
                    class="d-flex align-items-center"
                    v-if="value.gold?.discount?.text > 0"
                  >
                    قیمت نهایی :
                    <span
                      class="d-flex mx-2 justify-content-center align-items-center flex-column"
                    >
                      <p class="text-decoration-line-through ma-0 text-right">
                        {{ persian(payPrice().price.toLocaleString()) }}
                      </p>
                      <h6 class="text-right ma-0">
                        {{ persian(value.gold.price.text?.toLocaleString()) }}
                      </h6>
                    </span>
                    <v-icon>mdi-currency-rial</v-icon>
                  </span>
                  <p v-else class="text-right my-2">
                    قیمت نهایی :
                    {{ persian(value.gold.price.text.toLocaleString()) }}
                    <v-icon>mdi-currency-rial</v-icon>
                  </p>
                </v-btn>
              </div>
            </template>

            <template
              v-if="
                item === 'weight' &&
                value.gold.weight.text?.toString().length > 0
              "
            >
              <div
                class="w-100"
                :class="value.gold.weight.line ? 'line pb-3' : null"
              >
                <p class="text-right my-2">
                  <v-icon>mdi-weight</v-icon>
                  وزن طلا: {{ persian(value.gold.weight.text) }} گرم
                </p>
              </div>
            </template>
            <template
              v-if="
                item === 'cutie' && value.gold.cutie.text?.toString().length
              "
            >
              <div
                class="w-100"
                :class="value.gold.cutie.line ? 'line pb-3' : null"
              >
                <p class="text-right my-2">
                  <v-icon>mdi-podium-gold</v-icon>
                  عیار: {{ persian(value.gold.cutie.text) }}
                </p>
              </div>
            </template>
            <!-- <template
              v-if="
                item === 'create_name' && value.gold.create_name.text?.length
              "
            >
              <div
                class="w-100"
                :class="value.gold.create_name.line ? 'line pb-3' : null"
              >
                <p class="text-right w-full my-2">
                  <v-icon class="inline-block align-middle ml-1"
                    >mdi-pencil</v-icon
                  >
                  <span
                    class="inline whitespace-normal break-words align-middle"
                  >
                    نام سازنده :
                    {{ value.gold.create_name.text }}
                  </span>
                </p>
              </div>
            </template> -->
            <template
              v-if="
                item === 'create_at' && value.gold.create_at.text?.length > 0
              "
            >
              <div
                class="w-100"
                :class="value.gold.create_at.line ? 'line pb-3' : null"
              >
                <p class="text-right my-2">
                  <v-icon>mdi-calendar-range</v-icon>
                  تاریخ ساخت: {{ getPersianDate(value.gold.create_at.text) }}
                </p>
              </div>
            </template>
            <template
              v-if="
                item === 'wages' &&
                value.gold.wages.value?.toString()?.length > 0
              "
            >
              <div
                class="w-100"
                :class="value.gold.wages.line ? 'line pb-3' : null"
              >
                <p class="text-right my-2">
                  اجرت ساخت:
                  {{
                    value.gold.wages.type == "percentage"
                      ? persian(value.gold.wages.value)
                      : persian(value.gold.wages.value.toLocaleString())
                  }}
                  <v-icon>{{
                    value.gold.wages.type == "percentage"
                      ? "mdi-sale"
                      : "mdi-currency-rial"
                  }}</v-icon>
                </p>
              </div>
            </template>
            <template
              v-if="
                item === 'fee' && value.gold.fee.value?.toString()?.length > 0
              "
            >
              <div
                class="w-100"
                :class="value.gold.fee.line ? 'line pb-3' : null"
              >
                <p class="text-right my-2">
                  کارمزد فروشنده:
                  {{
                    value.gold.fee.type == "percentage"
                      ? persian(value.gold.fee.value)
                      : persian(value.gold.fee.value.toLocaleString())
                  }}
                  <v-icon>{{
                    value.gold.fee.type == "percentage"
                      ? "mdi-sale"
                      : "mdi-currency-rial"
                  }}</v-icon>
                </p>
              </div>
            </template>
            <template v-if="item === 'tax' && value.gold.tax.text > 0">
              <div
                class="w-100"
                :class="value.gold.tax.line ? 'line pb-3' : null"
              >
                <p class="text-right my-2">
                  مالیات طلا: {{ persian(value.gold.tax.text) }}
                  <v-icon>mdi-sale</v-icon>
                </p>
              </div>
            </template>
          <template v-if="item === 'discriptions' && value.gold.discriptions.text?.toString().length > 0">
            <div
              class="w-100 pt-1"
              style="z-index: 5"
              :class="value.gold.discriptions.line ? 'line pa-3' : null"
            >
              <p class="text-right my-2">
                <v-icon :color="value.pallete.textColor">mdi-text-box-edit</v-icon>
                درباره طلا:
                <span v-html="formattedText"></span>
                <br />
                <span
                  @click="isExpanded = !isExpanded"
                  class="blue--text mt-2"
                  style="cursor: pointer !important; font-size: 12px; font-weight: bold;"
                  v-if="value?.gold?.discriptions?.text && value.gold.discriptions.text.length > showMore"
                >
                  {{ isExpanded ? "نمایش کمتر" : "نمایش بیشتر" }}
                </span>
              </p>
            </div>
          </template>

            <template
              v-if="
                item === 'discount' &&
                value.gold?.discount?.text > 0 &&
                value.gold?.discount?.text !== null
              "
            >
              <div
                class="w-100"
                :class="value.gold.discount.line ? 'line pb-3' : null"
              >
                <p class="text-right my-2">
                  تخفیف: {{ value.gold?.discount?.text }}
                  <v-icon>mdi-sale</v-icon>
                </p>
              </div>
            </template>
            <template v-if="item === getAsstes(item).asset_id">
              <v-btn
                :style="{
                  background: value.pallete.headColor,
                  color: value.pallete.textColor,
                }"
                elevation="0"
                :loading="loading[item]"
                class="my-2"
                width="150px"
                height="auto"
              >
                <div
                  :style="{
                    maxWidth: '150px',
                    whiteSpace: 'normal',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    minHeight: 'auto',
                  }"
                >
                  <span class="" style="word-break: break-word; width: 100%">
                    {{ getAsstes(item).name }}
                  </span>
                  <span
                    class="mt-1"
                    style="word-break: break-word; width: 100%"
                  >
                  {{ persian(assetPrices[item].toLocaleString()) }} ﷼
                  </span>
                </div>
              </v-btn>

              <v-icon
                @click="getPrice(item)"
                :disabled="loading[item]"
                style="cursor: pointer"
                class="mr-2"
              >
                mdi-reload
              </v-icon>
            </template>

            <template v-if="item === 'img'">
              <image-slider v-model="value.photo.gallery" />
            </template>

            <template v-if="item === 'video'">
              <div
                class="col-md-12 w-100 pt-0 mt-0"
                style="overflow-x: auto; width: "
              >
                <b-gallery-view-gold
                  v-if="
                    value &&
                    !!value.gold.video &&
                    !!value.VideoGallery &&
                    value.VideoGallery.sectionColor
                  "
                  v-model="value.video_gallery"
                  :description="value.VideoGallery.description"
                  :is-img="false"
                  :settings="false"
                  :style="{
                    background: value.VideoGallery.sectionColor.backGround,
                    color: value.VideoGallery.sectionColor.text,
                    width: '',
                  }"
                  :title="value.VideoGallery.title"
                  type="video_gallery"
                />
              </div>
            </template>

            <template
              v-if="typeof item === 'string' && item.startsWith('more_')"
            >
              <div
                class="w-100"
                :class="getMores(item).line ? 'line pb-3' : null"
                @click="
                  !!getMores(item).link ? goToUrl(getMores(item).link) : null
                "
              >
                <p
                  @click="
                    !!getMores(item).link ? goToUrl(getMores(item).link) : null
                  "
                  class="text-right my-2"
                >
                  <v-icon v-if="getMores(item).icon">{{
                    getMores(item).icon
                  }}</v-icon>
                  <span v-if="getMores(item).label">{{
                    getMores(item).label
                  }}</span
                  >: {{ getMores(item).text }}
                </p>
              </div>
            </template>
          </template>
        </drag-list>
      </div>
    </v-card>
  </div>
</template>

<script>
import SaleTag from "./sales.vue";
import dragList from "../../qrland/dragList.vue";
import ImageSlider from "@/view/components/Gallery/imageSlider";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import bGalleryViewGold from "./bGalleryViewGold.vue";
import FloatingBtnGold from "./floatingBtnGold.vue";
import UniversalQrModal from "../../../components/UniversalQrModal.vue";

export default {
  name: "newFactoryLabel",
  components: {
    SaleTag,
    dragList,
    ImageSlider,
    BGalleryView,
    bGalleryViewGold,
    FloatingBtnGold,
    UniversalQrModal
  },
  props: {
    value: [Object],
    order: Array,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showQrDialog:false,
      showMore: 150,
      isExpanded: false, 
      socialMedia: [],
      socialMediaSlice: [],
      socialCount: 3,
      cardHeight: 0,
      isOverFlowLabel: false,
      isOverFlowLabelName: false,
      fixedWidth: 200,
      imageHeight: 500,
      loading: {},
      assetPrices: {},
      goldPrice: 0,
      url: this.$qrApi + "/v2/gold/db",
      dbLoading: false,
    };
  },
  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
    gold: {
      get() {
        return this.order;
      },
      set(val) {
        this.$emit("update:order", val);
      },
    },
  formattedText() {
    const text = this.value?.gold?.discriptions?.text;
    if (typeof text !== "string") return "";
    
    if (!this.isExpanded && text.length > this.showMore) {
      let truncated = text.substring(0, this.showMore);
      const lastSpace = truncated.lastIndexOf(" ");
      
      if (lastSpace > 0) {
        truncated = truncated.substring(0, lastSpace);
      }
      
      return truncated.replace(/\n/g, "<br>") + " ...";
    }      
    
    return text.replace(/\n/g, "<br>");
  },
  },
  watch: {
    "value.socialMedia": {
      immediate: true,
      deep: true,
      handler(val) {
        const slice = Object.values(val).flat();
        this.socialMedia = slice;
        this.socialMediaSlice = slice.slice(0, 3);
      },
    },
    "value.gold": {
      immediate: true,
      deep: true,
      handler(val) {
        this.setLabelKeys();
      },
    },
    "value.gold.model": {
      deep: true,
      handler() {
        this.getPrices();
      },
    },
    "value.myassets": {
      deep: true,
      handler(val) {
        this.setLabelKeys();
      },
    },
    "value.gold.goldName": {
      immediate: true,
      handler() {
        this.checkOverflow();
      },
    },
    "value.gold.name": {
      immediate: true,
      handler() {
        this.checkOverflowName();
      },
    },
    "value.gold.cutie.text"(val) {
      if (val == 24) {
        this.getPrices(this.value.gold.model.value);
      } else if (val == 18) {
        this.getPrices(this.value.gold.model.value);
      }
    },
    value: {
      deep: true,
      handler() {
        this.menuBackground();
      },
    },
  },
  methods: {
    getMores(item) {
      let index = parseInt(item.replace("more_", ""));
      return this.value?.gold?.more[index] || {};
    },
    addSocialMedia() {
      this.socialMediaSlice = this.socialMedia;
    },
    deletSocialMedia() {
      this.socialMediaSlice = this.socialMedia.slice(0, 3);
    },
    setLabelKeys() {
      let currentOrder = [...this.gold];

      const validKeys = Object.keys(this.value.gold).filter(
        (key) =>
          key !== "myassets" &&
          key !== "model" &&
          key !== "more" &&
          key !== "name" &&
          key !== "goldName" &&
          this.isValidValue(
            this.value.gold[key].text ?? this.value.gold[key].value,
            key,
          ),
      );

      const assetKeys = Object.values(this.value.myassets)
        .flat()
        .filter((asset) => asset.asset_id)
        .map((asset) => {
          let ass = asset.close_price;
          this.assetPrices = { ...this.assetPrices, [asset.asset_id]: ass };
          this.loading = { ...this.loading, [asset.asset_id]: false };
          return asset.asset_id;
        });

      const moreKeys = this.value.gold?.more.map((item, index) => {
        return `more_${index}`;
      });

      // ترکیب کلیدها
      const allValidKeys = [...validKeys, ...assetKeys, ...moreKeys];

      // فیلتر currentOrder برای نگه داشتن فقط کلیدهای معتبر
      let newOrder = currentOrder.filter((item) =>
        allValidKeys.includes(item.name),
      );

      // اضافه کردن کلیدهای جدید (اگر در currentOrder نباشند)
      allValidKeys.forEach((key) => {
        if (!newOrder.some((item) => item.name === key)) {
          newOrder.push({ name: key });
        }
      });

      // به‌روزرسانی gold فقط در صورت تغییر
      if (JSON.stringify(newOrder) !== JSON.stringify(this.gold)) {
        this.gold = newOrder;
      }
    },
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
    payPrice() {
      const gold = this.value?.gold || {};
      const discountPercent = Number(gold?.discount?.text) || 0;
      const weight = Number(gold?.weight?.text) || 0;
      const goldPrice = Number(this.goldPrice) || 0;
      const wagesValue = Number(gold?.wages?.value) || 0;
      const feeValue = Number(gold?.fee?.value) || 0;
      const taxPercent = Number(gold?.tax?.text) || 0;

      // اجرت
      const wages =
        gold.wages?.type === "percentage"
          ? goldPrice * wagesValue * 0.01
          : wagesValue * weight;

      // کارمزد
      const fee =
        gold.fee?.type === "percentage"
          ? goldPrice * feeValue * 0.01
          : feeValue * weight;

      // مالیات
      const taxBase = wages + fee;
      const tax = taxBase * taxPercent * 0.01;

      // قیمت نهایی
      const price = goldPrice * weight + wages + fee + tax;

      // اعمال تخفیف
      const priceDiscount = price - price * discountPercent * 0.01;

      // ذخیره‌سازی
      if (!gold.price) gold.price = {};
      gold.price.text =
        discountPercent > 0 ? Math.round(priceDiscount) : Math.round(price);

      return {
        price: Math.round(price),
        priceDiscount: Math.round(priceDiscount),
      };
    },
    isValidValue(value, key) {
      if (value == 0) return false;
      if (value == null || value === "") return false;
      if (typeof value === "string") return value.trim().length > 0;
      if (typeof value === "number") return true;
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === "object" && value?.text != null)
        return value?.text?.toString().trim().length > 0;
      if (typeof value == "boolean") return value;
      if (typeof value === "object" && value?.text == null) return false;

      return !!value;
    },
    getPersianDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return "تاریخ نامعتبر";
      return new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);
    },
    async getPrices(url) {
      this.dbLoading = true;

      let datas = [];
      try {
        await this.$api
          .get(
            this.$qrApi + "/v2/gold/db",
            {
              params: {
                type: "gold",
                length: "1000",
                source: this.value.gold.model.source,
              },
            },

            {
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*",
              "Content-Type": "application/json",
            },
          )
          .then(({ data }) => {
            datas = data.data.data;
          });

        if (this.value.gold.cutie.text == 24) {
          this.goldPrice = datas.find(
            (item) =>
              /(۲۴|24)\s*عیار/.test(item.name) && !/خرید/.test(item.name),
          ).close_price;
        } else if (this.value.gold.cutie.text == 18) {
          this.goldPrice = datas.find(
            (item) =>
              /(۱۸|18)\s*عیار/.test(item.name) && !/خرید/.test(item.name),
          ).close_price;
        }
      } catch (err) {
        // this.getPrices(url);
      } finally {
        this.dbLoading = false;
        this.payPrice();
      }
    },
    getAsstes(type) {
      let keys = Object.keys(this.value.myassets);

      let find = {};
      keys.forEach((item) => {
        this.value.myassets[item].map((sec) => {
          if (sec.asset_id == type) {
            find = sec;
          }
        });
      });
      return find;
    },
    async getPrice(id) {
      this.loading[id] = true;
      try {
        const data = await this.$api.get(this.$qrApi + "/v2/gold/db", {
          params: { assets: id },
        });

        this.assetPrices[id] = data.data.data.data[0].close_price;

        if (
          (/(۱۸|18)\s*عیار/.test(data.data.data.data[0].name) &&
            !/خرید/.test(data.data.data.data[0].name)) ||
          (/(۲۴|24)\s*عیار/.test(data.data.data.data[0].name) &&
            !/خرید/.test(data.data.data.data[0].name))
        ) {
          this.getPrices();
        }
      } catch (err) {
        console.error("Error fetching price:", err);
      } finally {
        this.loading[id] = false;
      }
    },
    checkOverflow() {
      this.$nextTick(() => {
        const textEl = this.$refs.textRef;
        const containerEl = this.$refs.containerRef;
        
        this.isOverFlowLabel = (textEl && containerEl)
          ? textEl.scrollWidth > (containerEl.clientWidth * 0.6)
          : false;
      });
    },

    checkOverflowName() {
      this.$nextTick(() => {
        const textEl = this.$refs.textName;
        const containerEl = this.$refs.containerLabelRef;
        
        this.isOverFlowLabelName = (textEl && containerEl)
          ? textEl.scrollWidth > (containerEl.clientWidth * 0.7)
          : false;
      });
    },
    menuBackground() {
      this.$nextTick(() => {
        const height = this.$refs.menuBackground;
        if (height) this.imageHeight = height.scrollHeight;
      });
    },
  },
  mounted() {
    const card = this.$refs.card_label;
    this.getPrices();
    this.resizeObserver = new ResizeObserver(() => {});
    this.resizeObserver.observe(card.$el || card);
    this.checkOverflow();
    this.checkOverflowName();
    this.menuBackground();
    window.addEventListener("resize", this.checkOverflow);
    window.addEventListener("resize", this.checkOverflowName);
    window.addEventListener("resize", this.menuBackground);
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener("resize", this.checkOverflow);
    window.removeEventListener("resize", this.checkOverflowName);
    window.removeEventListener("resize", this.menuBackground);
  },
};
</script>

<style scoped>
.image_style {
  width: 120px;
  height: 120px;
  border-radius: 100%;
  position: absolute;
  z-index: 2;
  right: -3%;
  top: -4%;
  animation: image-scale 3s ease-in-out 0s 1 forwards;
}
.menu {
  position: absolute;
  bottom: 30%;
  left: 15%;
  animation: menu-scale 2s ease-in-out 0s 1 forwards;
}
.social {
  animation: social-scale 3s ease-in-out 1 forwards;
}
.marquee-container {
  overflow: hidden;
  white-space: nowrap;
  position: relative;
}
.marquee-text {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 10s linear infinite;
}
.marquee-text-slow {
  display: inline-block;
  animation: marquee 14s linear infinite; 
}
.line {
  border-bottom: 1px solid rgb(206, 204, 204);
}
@keyframes marquee {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes image-scale {
  0% {
    transform: translateX(-100px);
    opacity: 0.4;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes menu-scale {
  0% {
    transform: translateY(100%);
    opacity: 0.4;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes social-scale {
  0% {
    transform: translateY(200%);
    opacity: 0.5;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.scrollable-icons::-webkit-scrollbar {
  width: 6px;
}

.scrollable-icons::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 6px;
}

.scrollable-icons::-webkit-scrollbar-track {
  background: transparent;
}

/* برای Firefox */
.scrollable-icons {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.5) transparent;
}
.qr-floating-btn {
  position: absolute;
  top: 10px;
  left: 44px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
